export const SET_FACTURES = 'SET_FACTURES';
export const SET_TOTAL_FACTURES = 'SET_TOTAL_FACTURES';
export const SET_AVOIR_A_CREER = 'SET_AVOIR_A_CREER';
export const SET_FACTURE_LAST_PAYLOAD = 'SET_COMMANDE_LAST_PAYLOAD';
export const SET_FACTURE = 'SET_FACTURE';
export const REMOVE_FACTURE = 'REMOVE_FACTURE';
export const SET_CRITERE = 'SET_CRITERE';
export const RESET_CRITERE = 'RESET_CRITERE';
